const e = () => typeof window < "u";
export {
  e as isBrowser
};
